import { uniq } from 'lodash-es'

const initialState = ({
  selectedKeys,
  allowMultiple
}) => ({
  selectedKeys: selectedKeys || [],
  allowMultiple: allowMultiple || false
})

const onKeyToggle = (state, { key }) => {
  let selectedKeys

  if (state.allowMultiple) {
    selectedKeys = state.selectedKeys.includes(key)
      ? state.selectedKeys.filter((selectedKey) => selectedKey !== key)
      : [...state.selectedKeys, key]
  } else {
    selectedKeys = state.selectedKeys.includes(key) ? [] : [key]
  }

  return {
    ...state,
    selectedKeys
  }
}

const onOpenKeys = (state, { keys }) => ({
  ...state,
  selectedKeys: uniq([...state.selectedKeys, ...keys])
})

const toggleKey = (key) => ({
  type: 'TOGGLE_KEY',
  payload: {
    key
  }
})

const openKeys = (keys) => ({
  type: 'OPEN_KEYS',
  payload: {
    keys
  }
})

const reset = (payload) => ({
  type: 'RESET',
  payload
})

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'TOGGLE_KEY':
      return onKeyToggle(state, payload)
    case 'OPEN_KEYS':
      return onOpenKeys(state, payload)
    case 'RESET':
      return initialState(payload)
    default:
      return state
  }
}


export {
  initialState,
  reducer,
  toggleKey,
  openKeys,
  reset
}
